import type { TicketProgress } from '@shared/schemas';
import { ticketUpdatedRelative } from '@/lib/ticket-meta';

/**
 * Q-6 «обновлён 14 мин назад» meta line · Ticket.tsx header + Board.tsx card.
 *
 * Renders nothing если ticket has no `updatedAt` field (legacy data · defensive).
 * Replaces inline `~Nм` heuristic с accurate relative time per ADR-007 sync
 * timestamps. Helper `ticketUpdatedRelative` @ cfa3c1a handles threshold logic.
 *
 * Optional `now` prop для tests / SSR / time-travel previews.
 */
export interface TicketUpdatedMetaProps {
  ticket: Pick<TicketProgress, 'updatedAt'> | undefined;
  /** Override «now» reference (default: current time at render). Useful for tests. */
  now?: Date;
  /** Custom prefix · defaults к «обновлён». */
  prefix?: string;
}

export function TicketUpdatedMeta({
  ticket,
  now,
  prefix = 'обновлён',
}: TicketUpdatedMetaProps) {
  const relative = ticketUpdatedRelative(ticket, now);
  if (!relative) return null;

  return (
    <span
      className="ticket-updated-meta"
      title={ticket?.updatedAt}
      style={{
        fontSize: 'var(--font-xs, 12px)',
        color: 'var(--ink-muted)',
        whiteSpace: 'nowrap',
      }}
    >
      {prefix} {relative}
    </span>
  );
}
